import {createStore, applyMiddleware, compose} from "redux";
// https://github.com/gaearon/redux-thunk
import thunk from "redux-thunk";
// https://github.com/evgenyrodionov/redux-logger
import logger from "redux-logger";

import RootReducer from "./reducers/rootReducer";

let composeEnhancers = compose;
const middlewares = [
  thunk,
];

if (process.env.NODE_ENV === "development") {
  if (typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 });
  }

  middlewares.push(logger);
}

const enhancer = composeEnhancers(
  applyMiddleware(...middlewares),
);

const configureStore = (preloadedState = {}) => {
  return createStore(
    RootReducer,
    preloadedState,
    enhancer);
};

export default configureStore;
